<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add spot</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New spot parameters by <span class="secondary--text">{{ set.item }}</span> set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" md="4" sm="6">
                                <v-select dense return-object
                                    v-model="team"
                                    :items="teams" 
                                    item-text="name"
                                    item-value="id"
                                    item-color="secondary" 
                                    label="team" 
                                    @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <v-select dense return-object
                                    v-model="trademark" 
                                    :items="filteredTrademarks" 
                                    item-text="name"
                                    item-value="id"
                                    color="secondary" 
                                    item-color="secondary" 
                                    label="trademark" 
                                    @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
							<v-col cols="12" sm="6" md="6">
								<v-select dense color="secondary" label="objective" v-model="objective"
									:items="objectives" item-color="secondary" :rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="3">
								<v-text-field dense color="primary" label="quality" v-model.number="quality"
									name="quality" type="text" suffix="level"
									hint="it's expected number between 1 and 5" persistent-hint
									:rules="[rules.required, rules.number, rules.max]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense color="primary" label="spot's budget" v-model.number="budget"
									name="budget" type="text" prefix="$" hint="it's expected number" persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="5">
								<v-text-field dense color="secondary" label="spot name" v-model="name" type="text"
									readonly>
								</v-text-field>
							</v-col>

							<v-col cols="12" sm="12" md="12">
								<v-select dense multiple color="secondary" label="channels" v-model="channels"
									:items="all_channels" item-color="secondary" :rules="[rules.required]"
									@change="onceMore()" @input="checkChannel($event)">
								</v-select>
							</v-col>
							<v-col cols="12" sm="12" md="12">
                                <v-select dense return-object color="secondary"
                                    :items="commercial_stories" 
                                    item-text="text"
                                    item-value="id"
                                    label="commercial store"
                                    v-model="commercial_story"
                                    item-color="secondary" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
							</v-col>
						</v-row>
						<v-row v-if="IsTargeted">	
							<v-col cols="12">Targeting parameters are available if at least one targeted channel is chosen</v-col>
							<hr />
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" label="min age" v-model.number="age_min" type="text"
									hint="it's expected number" persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" label="max age" v-model.number="age_max" type="text"
									hint="it's expected number" persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore($event)">
								</v-text-field>
							</v-col>
							
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="dominant gender"
									v-model="gender" :items="DOMINANT_GENDER"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="income range"
									v-model="income" :items="INCOME_RANGE"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="education"
									v-model="education" :items="EDUCATION" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="civil status"
									v-model="status" :items="CIVIL_STATUS"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="workplace"
									v-model="workplace" :items="WORKPLACE" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="lifestyle"
									v-model="lifestyle" :items="LIFESTYLE" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
						</v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-center text-pre-wrap mx-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)"
                    @click="calculating">
                    Calculate
                </v-btn>
                
                <v-btn color="secondary" text class="text-capitalize" 
                    :disabled="!calculate || Boolean(error)"
                    @click="addSpot">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" 
                    @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { CheckBudget, SpotCoverageCost, SpotInvestments } from '../../../functions/promotion.js'

export default {
    name: 'AddSpot',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            calculate: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
                max: v => v <= 5 || 'max 5 expected',
            },
            //props
            trademark: null,
            team: null,
            channels: [],
			commercial_story: {},
			objective: '',
			quality: 1,
			investments: 0,
			budget: 0,
			coverage_general: 0,
			coverage_targeted: 0,
			age_min: 0,
			age_max: 0,
			gender: 'any',
			income: 'any',
			education: 'any',
			status: 'any',
			workplace: 'any',
			lifestyle: 'any',
			IsTargeted: false,            
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        teams() {
            return this.$store.getters.teams;
        },
        segments() {
            return this.$store.getters.market_segments;
        },
        trademarks() {
            return this.$store.getters.trademarks;
        },
        media() {
			return this.$store.getters.media;
		},
        commercial_stories() {
			return this.$store.getters.commercial_stories;
		},
        /*constants*/
		all_channels() {
			return this.$store.getters.CHANNELS;
		},
		objectives() {
			return this.$store.getters.OBJECTIVES;
		},
		DOMINANT_GENDER () {
			return this.$store.getters.DOMINANT_GENDER;
		},
		INCOME_RANGE() {
            return this.$store.getters.INCOME_RANGE;
        },
        EDUCATION() {
            return this.$store.getters.EDUCATION;
        },
        CIVIL_STATUS() {
            return this.$store.getters.CIVIL_STATUS;
        },
        WORKPLACE() {
            return this.$store.getters.WORKPLACE;
        },
        LIFESTYLE() {
            return this.$store.getters.LIFESTYLE;
        },
       
        filteredTrademarks() {
            if (this.team) {
                const arr = [];
                this.team?.products.map(prod => {
                    const inArr = arr.find(it => it === prod.trademarkId)
                    if (!inArr) {
                        arr.push(prod.trademarkId)
                    }
                })
                const res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
                return res
            }
            return this.trademarks
        },
        marketSize() {
            let res = 0;
            if (this.segments.length > 0) {
                res = this.segments.reduce((sum, seg) => {
                    return sum+= seg.segment?.peak_size;
                }, 0)
            }
            /* console.log(res) */
            return res;
        },
        name:{ 
            get() {
                if (this.trademark) {
                    return `${this.trademark.name} Ads`
                }
                return ''
            },
            set(val) {
                return val;
            }
        }
    },
    watch: {
        async set() {
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        },
        
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },
        onceMore() {
            this.error = ''
            this.calculate = false;
            this.message = '';
        },
        checkChannel(event) {
			const arr = ['SMM', 'content ads', 'bloggers & influencers', 'banner ads'];
			for (let i=0; i < event.length; i++) {
				if (arr.includes(event[i])) {
					this.IsTargeted = true;
					return;
				}
			}
			this.IsTargeted = false;
		},
        calculating() {
            if (this.$refs.form.validate()) {

				const exist = this.spots?.find(spot => spot.name == this.name)
				if (exist) {
					return this.error = `Promotion spot of the trademark ${exist.name.split(' ')[0]} already exists`
				}

				//check budget
				const check_budget = CheckBudget(this.channels, this.media, this.budget);
				/* console.log(check_budget); */
				if (!check_budget) {
					return this.error = `you don't have enough budget: ${this.budget}`;
				}

				this.investments = SpotInvestments(this.quality, this.channels);
				/* chennels coverage */
				[this.coverage_general, this.coverage_targeted] = SpotCoverageCost(this.channels, this.marketSize, this.media, check_budget); 

				this.message = `Please, mention the figures:
					spot investments = ${this.localeNumber(this.investments)}
					market coverage by general advertising = ${this.localeNumber(this.coverage_general)}
					market coverage by targeted advertising = ${this.localeNumber(this.coverage_targeted)} 
					_______________________________________
					if you agree, press the button Save`;
				this.calculate = true;
			
            }
        },
        async addSpot() {

            if (this.$refs.form.validate()) {

                const typical_age = [];
				
				if (this.age_min || this.age_max) {
					typical_age[0] = this.age_min;
					typical_age[1] = this.age_max;
				}
                
                const spot = {
                    gameId: Number(this.set.value),
                    round: Number(this.round),
                    register_round: Number(this.round),
                    team: this.team,
                    name: this.name,
                    objective: this.objective,
					quality: this.quality,
					trademark: this.trademark,
					commercial_story: this.commercial_story,
					channels: this.channels,
					investments: this.investments,
					budget: this.budget,
					coverage_general: this.coverage_general,
					coverage_targeted: this.coverage_targeted,
					typical_age: typical_age,
					gender: this.gender,
					income: this.income,
					education: this.education,
					civil_status: this.status,
					job: this.workplace,
					lifestyle: this.lifestyle,
                }
                /* console.log(spot);*/ 
                try {
                    //add spot 
                    await this.$store.dispatch('addSpot', spot);
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.calculate = false;

            this.name = '';
            this.$refs.form.reset();
            this.channels = []
            this.team = null
            this.objective = ''
            this.quality = 1
            this.gender = 'any';
			this.income = 'any';
			this.education = 'any';
			this.status = 'any';
			this.workplace = 'any';
			this.lifestyle = 'any';
			this.IsTargeted = false;
        }
    },
    async mounted() {
        
        if (this.trademarks.length < 1) {
            try {
                await this.$store.dispatch('fetchTrademarks');
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.teams.length < 1) {
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.segments.length < 1) {
            const params = {
                gameId: this.set.value,
                round: this.round,
            }
            try {
                await this.$store.dispatch('fetchMarketSegments', params);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message);
            }
        }
        if (!this.commercial_stories && this.segments) {
            const category = this.segments[0].segment?.category;
			try {
				await this.$store.dispatch('fetchCommercialStories', category);
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}
		}

		if (!this.media) {
			try {
				await this.$store.dispatch('fetchMedia', {
					gameId: this.set.value, round: this.round
				});
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}
		}
    }
}
</script>
